const $ = jQuery.noConflict();

function isTouchDevice() {
    return 'ontouchstart' in window || navigator.msMaxTouchPoints;
}
class MegaMenu {
    constructor() {
        this.header = $('.main-header');
        this.menu = this.header.find('.main-header__nav');
        this.headerLinks = this.menu.find('> .menu > li > a');
        this.menuItems = this.menu.find('> .menu > .menu-item');
        this.subMenuItem = $('.sub-menu-wrapper').find('.sub-menu > li');
        this.subMenu = $('.sub-menu-wrapper').find('.sub-menu');
    }
    static showMegaMenu(e) {
        const subMenuWrapper = $(this).find('.sub-menu-wrapper');
        const subMenuListItems = subMenuWrapper.find('.sub-menu > li');
        const subMenuLinks = subMenuListItems.find('> a');
        const megaMenuWrapper = $(this).find('.mega-menu-wrapper');
        const megaMenuWrapperFirst = megaMenuWrapper.eq(0);
        const megaMenuWrapBackgr = subMenuWrapper.find('.mega-menu-wrapper-background');
        const timer = $('.main-header .mega-menu-background').height() !== 0 ? 0 : 250;
        $(this).find('> a').addClass('open');

        megaMenuWrapBackgr.css('width', megaMenuWrapperFirst.outerWidth());
        if($('.main-header').hasClass('main-header--transparent')) {
            MegaMenu.removeTransparency();
        }
        
        MegaMenu.subMenuTimeout = setTimeout(() => {
            MegaMenu.animateItemsIn(subMenuLinks);
            subMenuWrapper.addClass('active');
            MegaMenu.animateMenuBackground(subMenuWrapper.outerHeight(), e);
        }, timer);        
    }
    static hideMegaMenu(e) {
        clearTimeout(MegaMenu.subMenuTimeout);
        const activeSubMenu = $('.sub-menu-wrapper.active');
        const activeSubMenuItems = activeSubMenu.find('*');
        const headerLinks = $('.main-header__nav').find('> .menu > li > a');
        headerLinks.removeClass('open');
        activeSubMenu.removeClass('active');
        activeSubMenuItems.removeClass('active');
        if(e.type === 'click') {
            MegaMenu.animateMenuBackground(0, e);
        }
        else {
            if($(e.relatedTarget).hasClass('main-header') || $(e.relatedTarget).closest('.main-header').length > 0) {
                MegaMenu.animateMenuBackground(0, e);
            }
            else {
                MegaMenu.animateMenuBackgroundHeader(0, e);
            }
        }
    }
    static animateItemsIn(items) {
        let delay = 0;
        items.each((i, v) => {
            delay += 0.05;
            $(v).css('transition-delay', `${delay}s`);
            $(v).addClass('active');
        });
    }

    static animateMenuBackground(height, e) {
        const mainHeader = $('.main-header');
        const megaMenuBackground = mainHeader.find('.mega-menu-background');
        
        if(height === null){
            height = 0
        }
        megaMenuBackground.stop().animate({
            height: `${height}px`,
        }, 300);
    }
    static animateMenuBackgroundHeader(height, e) {
        const mainHeader = $('.main-header');
        const megaMenuBackground = mainHeader.find('.mega-menu-background');
        const headerLinks = $('.main-header__nav').find('> .menu > li > a');
        
        if(height === null){
            height = 0
        }
        megaMenuBackground.stop().animate({
            height: `${height}px`,
        }, 300, () => {
            if(!headerLinks.hasClass('open') && !mainHeader.hasClass('main-header--white')) {
                mainHeader.addClass('main-header--transparent');
            }
        });
    }
    static showInnerMenu() {
        
        const megaMenuWrapper = $(this).find('.mega-menu-wrapper');
        const submenuLinks = $(this).find('> a');
        const megaMenuWrapperLinks = megaMenuWrapper.find('a');
        const subMenu = $(this).closest('.sub-menu');
        const subMenuWrapper = $(this).closest('.sub-menu-wrapper');
        const timer = $('.main-header .mega-menu-background').height() !== 0 ? 0 : 250;

        submenuLinks.addClass('active-link');

        MegaMenu.innerMenuTimeout = setTimeout(() => {
            MegaMenu.animateItemsIn(megaMenuWrapperLinks);
            megaMenuWrapper.addClass('active');
            subMenu.css('height', megaMenuWrapper.outerHeight());
            if(subMenuWrapper.outerHeight() > megaMenuWrapper.outerHeight()) {
                MegaMenu.animateMenuBackground(subMenuWrapper.outerHeight());
            }
            else {
                MegaMenu.animateMenuBackground(megaMenuWrapper.outerHeight());
            }
            
        }, timer);
    }
    static hideInnerMenu() {
        clearTimeout(MegaMenu.innerMenuTimeout);
        const allActiveLinks = $('.sub-menu-wrapper').find('a.active-link');
        const activeMMWrapper = $('.mega-menu-wrapper.active');
        const activeMMWrapperLinks = activeMMWrapper.find('a');

        allActiveLinks.removeClass('active-link');
        activeMMWrapper.removeClass('active');
        activeMMWrapperLinks.removeClass('active');
    }
    static addTransparency(e) {
        MegaMenu.animateMenuBackgroundHeader(0, e); 
    }   
   
    static removeTransparency(e) {
        const mainHeader = $('.main-header');
        if(mainHeader.hasClass('main-header--transparent')) {
            mainHeader.removeClass('main-header--transparent');
        } 

    }
    toggleMegaMenu(e) {
        const mainMenuItem = $(e.target).parent();
        if(mainMenuItem.hasClass('menu-item-has-children')) {
            e.preventDefault();
            const headerLinks = $('.main-header__nav').find('> .menu > li > a');
            const subMenuWrapper = $(this).next('.sub-menu-wrapper');
            const subMenuListItems = subMenuWrapper.find('.sub-menu > li');
            const subMenuLinks = subMenuListItems.find('> a');
            const mainHeader = $('.main-header');
            const megaMenuWrap = subMenuWrapper.find('.mega-menu-wrapper').eq(0);
            const megaMenuWrapBackgr = subMenuWrapper.find('.mega-menu-wrapper-background');
            
            megaMenuWrapBackgr.css('width', megaMenuWrap.outerWidth());

            if (subMenuWrapper.hasClass('active')) {      
                return;
            }
            else {
                MegaMenu.hideInnerMenu();
                MegaMenu.hideMegaMenu(e);
                headerLinks.removeClass('open');
                $(this).addClass('open');
                if($(mainHeader).hasClass('main-header--transparent')) {
                    $(mainHeader).removeClass('main-header--transparent');
                }
                setTimeout(() => {
                    subMenuLinks.each((i, v) => {
                        MegaMenu.animateItemsIn($(v));
                    });
                    if($(this).next('.sub-menu-wrapper').length !== 0) {
                        subMenuWrapper.addClass('active');
                        MegaMenu.animateMenuBackground(subMenuWrapper.outerHeight(), e);                
                    }
                }, 200);
            }
        }
    }
    static hideMegaMenuOnTouch(e) {
        const container = $('.main-header__nav');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            MegaMenu.hideMegaMenu(e);
            MegaMenu.addTransparency();
        }
    }
    static toggleInnerMenu(e) {
        e.preventDefault();
        const clickedLink = $(this).find('> a');
        const subMenu = $(this).closest('.sub-menu');
        const megaMenuWrapper = $(this).find('.mega-menu-wrapper');
        const megaMenuWrapperLinks = megaMenuWrapper.find('a');
        const timer = $('.main-header .mega-menu-background').height() !== 0 ? 0 : 250;

        if(clickedLink.hasClass('active-link')) {
            return;
        }
        else {  
            clearTimeout(MegaMenu.innerMenuTimeout);
            MegaMenu.hideInnerMenu();
            clickedLink.addClass('active-link');
            MegaMenu.innerMenuTimeout = setTimeout(() => {
                MegaMenu.animateItemsIn(megaMenuWrapperLinks);
                megaMenuWrapper.addClass('active');
                subMenu.css('height', megaMenuWrapper.outerHeight());
                MegaMenu.animateMenuBackground(megaMenuWrapper.outerHeight())
            }, timer);
        }
    }
    bindEvents() {

        if (isTouchDevice()) {
            this.headerLinks.on('click', this.toggleMegaMenu);
            $(document).on('click touchstart', MegaMenu.hideMegaMenuOnTouch);
            this.subMenuItem.on('click', MegaMenu.toggleInnerMenu);
        } else {
           
            this.menuItems.on('mouseenter', MegaMenu.showMegaMenu);
            this.menuItems.on('mouseleave', MegaMenu.hideMegaMenu);
            this.subMenuItem.on('mouseenter', MegaMenu.showInnerMenu);
            this.subMenuItem.on('mouseleave', MegaMenu.hideInnerMenu);
            this.header.on('mouseenter', MegaMenu.removeTransparency);
            this.header.on('mouseleave', MegaMenu.addTransparency);
        }
    }
    showArrows() {
        if(isTouchDevice()) {
            $('.sub-menu-wrapper').addClass('touch-device');
        }
        this.subMenuItem.each((i, elem)=>{
            const menuInner = $(elem).find('.menu');
            if(menuInner.length > 0) {
                $(elem).addClass('arrow-visible');
            }
        });
    }
    init() {
        this.showArrows();
        this.bindEvents();
    }
}
export default new MegaMenu();
    